module.exports = __webpack_public_path__ + "static/media/about_banner_img.c4f6a46b.png";